// src/App.js
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaSpotify,
  FaApple,
  FaSoundcloud,
} from 'react-icons/fa';
import { useEffect } from 'react';

export default function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    script.async = true;
    script.onload = () => {
      const ShopifyBuy = window.ShopifyBuy;
      if (!ShopifyBuy) return;

      const client = ShopifyBuy.buildClient({
        domain: 'bkt4un-7v.myshopify.com',
        storefrontAccessToken: 'b9e92f6f922cf2d340c902a10abd2a77',
      });

      ShopifyBuy.UI.onReady(client).then((ui) => {
        ui.createComponent('product', {
          id: '8942559002840',
          node: document.getElementById('product-component-1753286796411'),
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: {
            product: {
              styles: {
                product: {
                  '@media (min-width: 601px)': {
                    maxWidth: 'calc(25% - 20px)',
                    marginLeft: '20px',
                    marginBottom: '50px',
                  },
                  'carousel-button': { display: 'none' },
                },
                title: { fontSize: '20px' },
                price: { fontSize: '19px' },
                compareAt: { fontSize: '16.15px' },
                unitPrice: { fontSize: '16.15px' },
              },
              contents: {
                img: false,
                imgWithCarousel: true,
              },
              width: '580px',
              text: {
                button: 'Add to cart',
              },
            },
            modalProduct: {
              contents: {
                img: false,
                imgWithCarousel: true,
                button: false,
                buttonWithQuantity: true,
              },
              styles: {
                product: {
                  '@media (min-width: 601px)': {
                    maxWidth: '100%',
                    marginLeft: '0px',
                    marginBottom: '0px',
                  },
                },
                title: {
                  fontFamily: 'Helvetica Neue, sans-serif',
                  fontWeight: 'bold',
                  fontSize: '26px',
                  color: '#4c4c4c',
                },
                price: {
                  fontFamily: 'Helvetica Neue, sans-serif',
                  fontWeight: 'normal',
                  fontSize: '18px',
                  color: '#4c4c4c',
                },
              },
              text: {
                button: 'Add to cart',
              },
            },
          },
        });

        ui.createComponent('product', {
          id: '8943822831832',
          node: document.getElementById('product-component-1753397677991'),
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: {
            product: {
              styles: {
                product: {
                  '@media (min-width: 601px)': {
                    maxWidth: 'calc(25% - 20px)',
                    marginLeft: '20px',
                    marginBottom: '50px',
                  },
                  'carousel-button': { display: 'none' },
                },
                title: { fontSize: '20px' },
                price: { fontSize: '19px' },
                compareAt: { fontSize: '16.15px' },
                unitPrice: { fontSize: '16.15px' },
              },
              contents: {
                img: false,
                imgWithCarousel: true,
              },
              width: '580px',
              text: {
                button: 'Add to cart',
              },
            },
            modalProduct: {
              contents: {
                img: false,
                imgWithCarousel: true,
                button: false,
                buttonWithQuantity: true,
              },
              styles: {
                product: {
                  '@media (min-width: 601px)': {
                    maxWidth: '100%',
                    marginLeft: '0px',
                    marginBottom: '0px',
                  },
                },
                title: {
                  fontFamily: 'Helvetica Neue, sans-serif',
                  fontWeight: 'bold',
                  fontSize: '26px',
                  color: '#4c4c4c',
                },
                price: {
                  fontFamily: 'Helvetica Neue, sans-serif',
                  fontWeight: 'normal',
                  fontSize: '18px',
                  color: '#4c4c4c',
                },
              },
              text: {
                button: 'Add to cart',
              },
            },
          },
        });
      });
    };
    document.body.appendChild(script);
  }, []);

  return (
    <main className="bg-black text-white font-sans">
      {/* Hero Section */}
      <header className="relative h-screen w-full overflow-hidden">
        <video autoPlay loop muted playsInline className="absolute top-0 left-0 w-full h-full object-cover">
          <source src="/video/hero-loop.webm" type="video/webm" />
          <source src="/video/hero-loop.mp4" type="video/mp4" />
          Your browser doesn’t support HTML5 video.
        </video>
        <div className="relative z-10 flex flex-col justify-center items-center h-full text-center px-4">
          <h1 className="text-6xl md:text-8xl font-bold drop-shadow-lg text-outline-green">DALE DALE</h1>
          <p className="text-xl md:text-4xl max-w-4xl text-outline-green">DJ | Drummer | Producer</p>
        </div>
      </header>
        {/* About Section */}
        <section className="p-8 md:p-16 bg-black" aria-label="About">
        <h2 className="text-4xl font-bold mb-6 text-center text-outline-green">About</h2>
        <p className="text-lg max-w-3xl mx-auto text-center">
          Dale Dale blends polyrhythmic dance music, advanced sound design, immersive video, and live drumming into an unforgettable fusion of folklore and futurism. Drawing on global percussive traditions, 
          he delivers high-energy performances as a DJ, drummer, and producer.
        </p>
      </section>

      {/* Footer Social Links */}
      <footer className="fixed bottom-4 left-0 w-full z-50 flex justify-center" role="contentinfo">
        <nav className="flex space-x-6 bg-black/50 px-6 py-2 rounded-full shadow-lg backdrop-blur">
          <a href="https://www.facebook.com/DaleDaleMusica/" target="_blank" rel="noopener noreferrer" title="Facebook"><FaFacebook className="text-green-400 text-4xl hover:scale-125" /></a>
          <a href="https://www.instagram.com/daledalemusica/" target="_blank" rel="noopener noreferrer" title="Instagram"><FaInstagram className="text-green-400 text-4xl hover:scale-125" /></a>
          <a href="https://www.youtube.com/@daledalemusic" target="_blank" rel="noopener noreferrer" title="YouTube"><FaYoutube className="text-green-400 text-4xl hover:scale-125" /></a>
          <a href="https://open.spotify.com/artist/46eZ3zuDpfq9y6dkvE0J0T" target="_blank" rel="noopener noreferrer" title="Spotify"><FaSpotify className="text-green-400 text-4xl hover:scale-125" /></a>
          <a href="https://music.apple.com/us/artist/dale-dale/1407854317" target="_blank" rel="noopener noreferrer" title="Apple Music"><FaApple className="text-green-400 text-4xl hover:scale-125" /></a>
          <a href="https://soundcloud.com/daledalemusica" target="_blank" rel="noopener noreferrer" title="SoundCloud"><FaSoundcloud className="text-green-400 text-4xl hover:scale-125" /></a>
        </nav>
      </footer>

      {/* Latest Tracks Section */}
      <section className="p-8 md:p-16 bg-green-900" aria-label="Latest Tracks">
        <h2 className="text-4xl font-bold mb-6 text-center text-outline-green">Latest Tracks</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <iframe width="100%" height="166" scrolling="no" frameBorder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/daledalemusica/dale-dale-tropicasa-5&color=%2300cc99&auto_play=false&show_teaser=true"></iframe>
          <iframe width="100%" height="166" scrolling="no" frameBorder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/daledalemusica/dada&color=%2300cc99&auto_play=false&show_teaser=true"></iframe>
          <iframe width="100%" height="166" scrolling="no" frameBorder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/daledalemusica/tropicasa-6-bailebass-mix&color=%2300cc99&auto_play=false&show_teaser=true"></iframe>
        </div>
      </section>

      {/* Watch Section */}
      <section className="p-8 md:p-16 bg-black" aria-label="Watch">
        <h2 className="text-4xl font-bold mb-6 text-center text-outline-green">Watch</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <iframe width="100%" height="315" loading="lazy" src="https://www.youtube.com/embed/nwCUH8AkQHc" title="YouTube video player" frameBorder="0" allowFullScreen></iframe>
          <iframe width="100%" height="315" loading="lazy" src="https://www.youtube.com/embed/iUgd9f9xs2I" title="YouTube video player" frameBorder="0" allowFullScreen></iframe>
        </div>
      </section>

      {/* Tour Section */}
      <section className="p-8 md:p-16 bg-green-900" aria-label="Tour Dates">
        <h2 className="text-4xl font-bold mb-6 text-center text-outline-green">Tour</h2>
        <ul className="space-y-4 max-w-2xl mx-auto text-center">
          <li className="text-lg">🗓️ Washington, DC — <strong>Date TBD</strong> Venue TBD </li>
          <li className="text-lg">🗓️ Brooklyn, NY — <strong>Date TBD</strong> Venue TBD</li>
          <li className="text-lg">🗓️ Miami, FL — <strong>Date TBD</strong> Venue TBD</li>
        </ul>
      </section>

      {/* Shop Section */}
      <section className="p-8 md:p-16 bg-black" aria-label="Shop">
        <h2 className="text-4xl font-bold mb-6 text-center text-outline-green">Shop</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto text-outline-green">
          <div id="product-component-1753286796411"></div>
          <div id="product-component-1753397677991"></div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="p-8 md:p-16 bg-green-900" aria-label="Contact">
        <h2 className="text-4xl font-bold mb-6 text-center text-outline-green">Join the Tribe</h2>
        <p className="mb-6 text-xl text-outline-green text-center">Want updates on new tracks, shows, and exclusive drops?</p>
        <form action="https://formsubmit.co/daledalemusica@gmail.com" method="POST" className="max-w-xl mx-auto space-y-4">
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_next" value="https://daledalemusica.com/thank-you" />
          <input type="text" name="name" placeholder="Your Name" required className="w-full p-3 rounded bg-black border border-green-500 text-white placeholder-green-300" />
          <input type="email" name="email" placeholder="Your Email" required className="w-full p-3 rounded bg-black border border-green-500 text-white placeholder-green-300" />
          <button type="submit" className="bg-yellow-400 hover:bg-yellow-300 text-black font-bold py-2 px-6 rounded w-full">Subscribe</button>
        </form>
      </section>
    </main>
  );
}
